export default "__VITE_ASSET__BR56n4mc__"